<script setup>
/* eslint-disable */
import { onMounted, onUnmounted, watch, ref } from 'vue';
import { useSocketStore } from '@/stores/socket';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useLiveSportOverview } from '@/stores/live_sport_overview';
import { useMarketsStore } from '@/stores/markets';
import { useGeneralStore } from '@/stores/general';
import { useRouter, useRoute } from 'vue-router';
import { useSportPopularStore } from '@/stores/sport_popular';

import PreSportFeaturedFixtures from '@/components/pre_sports/PreSportFeaturedFixtures.vue';
import LiveOverview from '@/components/pre_sports/highlights/LiveOverview.vue';
import UpcomingOverview from '@/components/pre_sports/highlights/UpcomingOverview.vue';
import PopularOverview from '@/components/pre_sports/highlights/PopularOverview.vue';
import { useI18n } from 'vue-i18n';
import { SportsData } from '@/stores/Sports';

const socketStore = useSocketStore();
const preSportsStore = usePreSportsStore();
const liveSportsStore = useLiveSportsStore();
const marketsStore = useMarketsStore();
const liveSportOverviewStore = useLiveSportOverview();
const generalStore = useGeneralStore();
const sportPopularStore = useSportPopularStore();
const SportsDataStore = SportsData();

const router = useRouter();
const route = useRoute();

const { t } = useI18n();

const show_scroll_to_top_button = ref(false);

const changeTab = (tab) => {
	active_tab.value = tab;
}

const props = defineProps({
	primary_overview_market: {
		type: Object,
		required: true,
	},
	sport: {
		type: Object,
		required: true,
	},
	active_tab: {
		required: true
	},
	fixtures_count: {
		type: Number,
		default: 5
	}
});

const handleScroll = () => {
	const scrollTop = window.scrollY;
	show_scroll_to_top_button.value = scrollTop > 100;
};


onMounted(() => {
	socketStore.join('sportHighlights', props.sport.id);
	liveSportOverviewStore.loading = true;
	socketStore.join('liveSportOverview', props.sport.id);

	window.addEventListener('scroll', handleScroll);

})

onUnmounted( () => {
	socketStore.leave('sportHighlights', props.sport.id);
	socketStore.leave('liveSportOverview');
	liveSportOverviewStore.emptyLiveSportsOverview();
})

watch(() => props.sport, (newSport, oldSport) => {

	liveSportOverviewStore.emptyLiveSportsOverview();
	socketStore.join('sportHighlights', newSport.id);
	liveSportOverviewStore.loading = true;
	socketStore.join('liveSportOverview', newSport.id);

}, {deep: true})


const scrollToTop = () => {
	window.scrollTo({ top: 0 });
};


</script>

<template>
	<PreSportFeaturedFixtures v-if="sportPopularStore.getTopFeaturedFixtures.length > 0"/>

	<div class="live-bet-dashboard round-games-main set_game-outer">

		<div class="live-tab-info" id="tabs">
			<LiveOverview v-if="active_tab == 'live'" :primary_overview_market="primary_overview_market" :secondary_overview_market="primary_overview_market" :landing="true" :fixtures_count="fixtures_count"/>
			<UpcomingOverview v-if="active_tab == 'upcoming'" :primary_overview_market="primary_overview_market" :secondary_overview_market="primary_overview_market" :sport="sport" :fixtures_count="fixtures_count"/>
			<PopularOverview v-if="active_tab == 'popular'" :primary_overview_market="primary_overview_market" :secondary_overview_market="primary_overview_market" :landing="true" :fixtures_count="fixtures_count"/>
		</div>
	</div>
	<button @click="scrollToTop" type="button" class="btn scroll-to-top" id="btn-back-to-top" v-show="show_scroll_to_top_button">
		<i class="fas fa-arrow-up"></i>
	</button>
</template>
<style scoped>


:deep(.live-bet-dashboard.round-games-main .bet-dashboard-top:after) {
	display:none !important;
}

@media screen and (min-width: 992px) and (max-width: 3000px) {
	button#btn-back-to-top {
		display:none;
	}
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	button#btn-back-to-top {
		bottom: 95px;
		left: 20px;
	}
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	svg.svg-inline--fa.fa-arrow-up.fa-w-14 {
		margin-bottom: 7px!important;
	}
	button#btn-back-to-top {
		width: 30px!important;
		height: 30px!important;
		font-size: 14px!important;
	}
}
button#btn-back-to-top {
	background: var(--primary);
	width: 38px;
	height: 38px;
	border: none;
	border-radius: 50%;
	position: fixed;
	z-index: 99;
	box-shadow: 0 2px 4px var(--list-gray);
	font-size: 16px;
	cursor: pointer;
}
html[dir="rtl"] button#btn-back-to-top {
	left: unset;
	right:20px;
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	button#btn-back-to-top {
		left: 10px;
	}
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	html[dir="rtl"] button#btn-back-to-top {
		left: unset;
		right:10px;
	}
}
@media screen and (min-width: 768px) {
	.tab-pills {
		padding-bottom: 12px;
	}
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	.dropdown-option-top-2 {
		display: none;
	}
}
@media screen and (min-width: 320px) and (max-width: 323px) {
	.last-btn {
		margin-top: 5px;
	}
}

html[dir="rtl"] .live-bet-dashboard .bet-dashboard-top:after {
	right: unset;
	left: 0px;
}

.live-tab-info {
	scrollbar-width: none !important;
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	.live-tab-info {
		min-height: unset;
		max-height: unset;
		height: unset;
	}
}
</style>